import { CanActivateFn } from '@angular/router';
import { fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth';

export const authGuard: CanActivateFn = async (route, state) => {
  try {
    const session = await fetchAuthSession();
    if (session.tokens?.idToken) {
      return true;
    }
  } catch (err) {
    console.error('Sessione non valida', err);
  }

  // Se non autenticato, reindirizza a Cognito Hosted UI
  await signInWithRedirect();
  return false;
};
